import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopOrderInput,
    PopOrder,
    UpdatePopOrderInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopOrderService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPopOrders(): Promise<PopOrder[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopOrders
                })
            ).data.listPopOrders.items;
            if (data) return data as PopOrder[];
        } catch (error) {
            console.error('Error finding PopOrder:', error);
            return null;
        }
    }

    async popOrderByCreatedAt(estatus: string): Promise<PopOrder[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.popOrderByCreatedAt,
                    variables: {
                        estatus
                    }
                })
            ).data.popOrderByCreatedAt.items;
            if (data) return data as PopOrder[];
        } catch (error) {
            console.error('Error finding PopOrder:', error);
            return null;
        }
    }

    async createPopOrder(input: CreatePopOrderInput): Promise<PopOrder> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopOrder,
                    variables: {
                        input
                    }
                })
            ).data.createPopOrder;
            if (date) return date as PopOrder;
        } catch (error) {
            console.error('Error creating PopOrder:', error);
            return null;
        }
    }

    async getPopOrder(id: string): Promise<PopOrder> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPopOrder,
                    variables: { id }
                })
            ).data.getPopOrder;
            if (data) return data as PopOrder;
        } catch (error) {
            console.error('Error finding PopOrder:', error);
            return null;
        }
    }

    async updatePopOrder(input: UpdatePopOrderInput): Promise<PopOrder> {
        return this.up(input);
    }

    async up(input: UpdatePopOrderInput): Promise<PopOrder> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopOrder,
                    variables: {
                        input
                    }
                })
            ).data.updatePopOrder;
            if (date) return date as PopOrder;
        } catch (error) {
            console.error('Error creating PopOrder:', error);
            return null;
        }
    }
}
